import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noMatches: {
		id: 'issue-field-assets.edit.no-matches',
		defaultMessage: 'No Matches',
		description: 'Select menu message. Shows there is no assets found',
	},
	failedFetch: {
		id: 'issue-field-assets.edit.failed-fetch',
		defaultMessage: 'Search failed. Please try again.',
		description: 'Message when fetching assets fails',
	},
});
